import Select, { SelectOptions } from '@/components/Controls/Select';
import './GroupedLinksListWidget.scss';

import Vue from 'vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { JSONParser } from '@/utils/JSONParser';

interface LinkParams {
    attrs: Record<string, string>;
    linePrimary: string;
    lineSecondary: string;
}

interface Group {
    groupTitle: string;
    links: LinkParams[];
}

type GroupList = Group[];

export function createGroupedLinksListWidget(el: Element) {
    const parser = new JSONParser('createGroupedLinksListWidget');
    const rootAttrs = new RootElementAttrsHolder(el);

    const rawList = el.getAttribute('data-list');

    return new Vue({
        el,
        name: 'GroupedLinksListWidget',
        rootAttrs,
        data: {
            list: parser.parse<GroupList>(rawList),
            active: 0,
        },
        computed: {
            selectOptions(): SelectOptions {
                return this.list?.map((item, i) => ({
                    label: item.groupTitle,
                    value: i,
                }));
            },
            selectedGroupLinks(): LinkParams[] {
                return this.list?.[this.active]?.links;
            },
        },
        render(h) {
            return (
                <div class="grouped-links-list">
                    <Select
                        v-model={this.active}
                        options={this.selectOptions}
                        class="grouped-links-list__select"
                    />
                    <transition name={'fade'} mode="out-in">
                        {this.selectedGroupLinks ? (
                            <ul class="grouped-links-list__list" key={this.active}>
                                {this.selectedGroupLinks?.map((link) => (
                                    <li>
                                        <a
                                            {...{ attrs: link.attrs }}
                                            class="grouped-links-list__link"
                                        >
                                            <div class="grouped-links-list__line-primary">
                                                {link.linePrimary}
                                            </div>
                                            <div class="grouped-links-list__line-secondary">
                                                {link.lineSecondary}
                                            </div>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : null}
                    </transition>
                </div>
            );
        },
    });
}
